import React, { useMemo, useState } from 'react';
import MediaViewerModal from '../../../../Components/MediaViewer/MediaViewerModal';
import {
	DocumentationFile,
	useDocumentationFilesQuery,
} from '../../../../graphql/graphql';
import { prepareDocumentationFileForMediaViewer } from '../../../Ecard/Services/eCardFile.service';
import { PreviewFile } from '../../../../Components/MediaViewer/MediaViewer';
import { useAppContext } from '../../../../Services/AppContext';

interface Props {
	documentationFileId: string;
	onClose: () => void;
}

const NotificationDocumentationFileModal: React.FC<Props> = ({
	documentationFileId,
	onClose,
}) => {
	const { data, isLoading } = useDocumentationFilesQuery({
		fileIds: [documentationFileId],
	});
	// @ts-ignore
	const { socketUrl, redirectToDashboard } = useAppContext();
	const file: PreviewFile | undefined = useMemo(() => {
		const documentationFile = data?.documentationFiles
			?.data?.[0] as DocumentationFile;
		if (documentationFile) {
			return prepareDocumentationFileForMediaViewer(
				documentationFile,
				socketUrl,
			);
		}
	}, [data]);

	if (file) {
		return <MediaViewerModal opened onClose={onClose} file={file} />;
	}

	return <></>;
};

export default NotificationDocumentationFileModal;
